import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { englishCrmMessages } from "./englishCrmMessages";

// English only. French was inherited from the upstream Atomic CRM template and
// removed on 2026-09-09 (LCATOMICZO-69): it was reachable only by setting your
// browser to French, nobody on the team did, and the catalog had drifted far
// enough behind English that those users were reading fallbacks anyway. Its 8
// missing-key type errors were a third of what the typecheck gate was hiding.
//
// Adding a language back means a catalog module, an entry in the locales list
// below, and a branch in the loader. LocalesMenuButton hides itself while there
// is only one locale, so the header picker reappears on its own.
const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

export const getInitialLocale = (): "en" => "en";

export const i18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  getInitialLocale(),
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
